export default __webpack_public_path__ + "static/media/20200418_104513.6c8d5de3.jpg";